import "./Contact.module.css";
import StudioCommandHeader from "@/reusable_sections/Header";
import StartAConversation from "./sections/StartAConversation";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <StudioCommandHeader />
      <StartAConversation />
      <Footer />
    </div>;
}